<template>
  <div
    class="border rounded-sm shadow-sm d-flex flex-column align-items-center justify-content-center py-4 bg-light"
    :style="styles"
  >
    <h4 class="my-0" style="color: #096537 !important">
      <strong>{{ value }}</strong>
      <slot name="unit"></slot>
    </h4>
    <p
      class="text-muted my-0 text-center"
      :style="{ color: labelColor + ' !important' }"
    >
      {{ label }}
    </p>
  </div>
</template>
<script>
import { StatsCard } from 'src/components/index';

export default {
  name: 'kpi',
  props: {
    value: {
      type: String | Number,
    },
    label: {
      type: String,
      default: null,
    },
    width: {
      type: String | Number,
      default: '100%',
    },
    labelColor: {
      type: String,
      default: '#096537',
    },
  },
  components: {
    StatsCard,
  },
  data() {
    return {};
  },
  computed: {
    styles() {
      return {
        width: this.width,
      };
    },
  },
};
</script>
